import type { ErrorEntry } from './types';

export const FRONTEND_ERROR_CATALOG: Record<string, ErrorEntry> = {
  git_access_denied: {
    action: { href: '/settings/integrations', label: 'Check Settings' },
    title: 'Git Access Denied',
    variant: 'destructive',
  },
  git_installation_not_found: {
    action: { href: '/settings/integrations', label: 'Reconnect' },
    title: 'Git Installation Not Found',
    variant: 'destructive',
  },
  git_token_invalid: {
    action: { href: '/settings/integrations', label: 'Update Token' },
    persistent: true,
    title: 'Git Token Invalid',
    variant: 'destructive',
  },
  git_token_revoked: {
    action: { href: '/settings/integrations', label: 'Reauthorize' },
    persistent: true,
    title: 'Git Token Revoked',
    variant: 'destructive',
  },
  internal_error: {
    title: 'Internal Error',
    variant: 'destructive',
  },
  pat_disabled: {
    title: 'Personal access tokens are disabled for this organization.',
    variant: 'destructive',
  },
  pat_expired: {
    title: 'This token has expired.',
    variant: 'destructive',
  },
  pat_expiration_too_long: {
    title: 'Expiration exceeds the organization limit. Please select a shorter duration.',
    variant: 'destructive',
  },
  pat_limit_exceeded: {
    title:
      'You have reached the maximum number of personal access tokens. Revoke an existing token to create a new one.',
    variant: 'destructive',
  },
  pat_name_exists: {
    title: 'A token with this name already exists. Choose a different name.',
    variant: 'destructive',
  },
  pat_not_found: {
    title: 'Token not found.',
    variant: 'destructive',
  },
  pat_revoked: {
    title: 'This token has been deleted.',
    variant: 'destructive',
  },
  subscription_exists: {
    action: { href: '/settings/billing', label: 'View Billing' },
    title: 'Subscription Already Exists',
    variant: 'warning',
  },
};
